interface VideoChaptersProps {
  chaptersVtt?: string
}

export const VideoChapters = ({ chaptersVtt }: VideoChaptersProps) => {
  if (!chaptersVtt) return null

  return (
    <track
      kind="chapters"
      src={URL.createObjectURL(new Blob([chaptersVtt], { type: 'text/vtt' }))}
      label="Chapters"
      default
    />
  )
}
